import React, { useState } from 'react';

import ColumnLayout from '../layouts/ColumnLayout';
import OrderTableComponent from '../components/OrderTableComponent';

export default function Inbox() {
  const [reloadRows, setReloadRows] = useState(true);

  return (
    // TODO - Handle Orders here that were delivered. Also remove them from the home page via backend ;)
    <div>
      <ColumnLayout childs={[
        (<h1>Recibidos</h1>),
        (<h3>Ordenes Judiciales Policiales</h3>),
        (<OrderTableComponent reloadRows={reloadRows} onSetReloadRows={setReloadRows} filter={'delivered'}/>),
        // TODO: Use the nested GRID please findout an easy way to send it through props...
      ]} />
    </div>
  );
}
